<template>
    <div class="text-xs-center">
        <v-dialog
                v-model="dialog"
                width="90%">
            <v-card>
                <v-toolbar color="primary" dark>
                    <v-toolbar-title>{{titleAction}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn @click="cancel()" dark icon>
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-card-text>
                    <v-container fluid grid-list-xl>
                        <v-layout wrap>
                            <v-flex d-flex lg12 md12 sm12 xs12>
                                <v-flex d-flex lg4 md4 sm12 xs12>
                                    <IgTextField
                                            :disabled="!Edit"
                                            :rules="[v => rules.vacio(v,'name')]"
                                            :status="dialog"
                                            :label="$t('name')"
                                            v-model="pitchName">
                                    </IgTextField>
                                </v-flex>
                                <v-flex md4 sm6 xs12>
                                    <v-text-field :disabled="true" prepend-icon='attach_file'
                                                  v-model="titleFile">
                                        <template slot="label">
                                            {{$t('image')}}
                                        </template>
                                    </v-text-field>
                                    <upload-button :fileChangedCallback="fileChanged" :title="titleButton"
                                                   :disabled="!Edit"/>
                                </v-flex>
                                <v-flex md4 sm6 v-if="image" xs12>
                                    <div style="max-width: 200px">
                                        <clipper-preview class="basic md" name="preview"></clipper-preview>
                                    </div>
                                </v-flex>
                                <v-flex md4 sm6 v-if="image && Edit" xs12>
                                    <div style="max-width: 200px">
                                        <clipper-basic
                                                :src="image" class="basic lg" preview="preview"></clipper-basic>
                                    </div>
                                </v-flex>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="create()" color="success" small v-if="externalAction === 'create'">{{$t('create')}}
                    </v-btn>
                    <v-btn @click="update()" color="secondary" small v-if="externalAction === 'update'">
                        {{$t('update')}}
                    </v-btn>
                    <v-btn @click="remove()" color="error" small v-if="externalAction === 'remove'">{{$t('delete')}}
                    </v-btn>
                    <v-btn @click="cancel()" color="primary" small>{{$t('cancel')}}</v-btn>
                    <v-btn @click="reset()" color="warning" small v-if="externalAction !== 'remove'">{{$t('reset')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import UploadButton from 'vuetify-upload-button'
import queueToast from '../../../helpers/queueToast'
import { clipperBasic, clipperPreview } from 'vuejs-clipper'
import { urlAvatar } from '../../../helpers/avatar'
import rules from '../../../helpers/rules'

export default {
  name: 'formManager',
  components: {
    UploadButton,
    clipperBasic,
    clipperPreview
  },
  mixins: [rules],
  props: {
    modal: {
      type: Boolean,
      default: false,
      required: true
    },
    Edit: {
      type: Boolean,
      default: false,
      required: false
    },
    externalAction: {
      type: String,
      default: 'create',
      required: false
    },
    externalPitch: {
      type: Object,
      default: () => {
        return {}
      },
      required: false
    },
    stadiumOmit: {
      type: Boolean,
      required: false,
      default: true
    },
    stadiumId: {
      type: String,
      required: false,
      default: ''
    }
  },
  data () {
    return {
      pitchName: '',
      category: '',
      stadium: '',
      image: '',
      file: '',
      titleFile: ''
    }
  },
  watch: {
    externalPitch: function () {
      this.actions()
    },
    externalAction: function () {
      this.actions()
    }
  },
  mounted () {
    this.pitchName = this.externalPitch.name
    this.image = this.externalPitch.photo ? urlAvatar + this.externalPitch.photo : ''
    this.file = ''
    this.titleFile = this.externalPitch.photo
    this.actions()
  },
  computed: {
    ...mapState({
      listStadiums: state => state.stadiums.listSelectStadiums
    }),
    dialog: {
      get () {
        return this.modal
      },
      set (value) {
        if (!value) {
          this.$emit('close')
        }
      }
    },
    titleAction () {
      switch (this.externalAction) {
        case 'create':
          return this.$t('newAModel', { field: this.$tc('pitch') })
        case 'remove':
          return this.$t('deleteModel', { field: this.$tc('pitch') })
        case 'update':
          return this.$t('updateModel', { field: this.$tc('pitch') })
      }
    },
    titleButton () {
      return this.image ? this.$t('change', { field: this.$t('image') }) : this.$t('upload', { field: this.$t('image') })
    }
  },
  methods: {
    ...mapActions({
      setCreate: 'pitches/setCreateNew',
      setUpdate: 'pitches/setUpdatePitch',
      setRemove: 'pitches/setDeletePitch'
    }),
    actions () {
      switch (this.externalAction) {
        case 'create':
          this.actionCreate()
          break
        case 'remove':
          this.actionRemove()
          break
        case 'update':
          this.actionUpdate()
          break
      }
    },
    actionUpdate () {
      let me = this
      setTimeout(function () {
        me.pitchName = me.externalPitch.name
        me.image = me.externalPitch.photo ? urlAvatar + me.externalPitch.photo : ''
        me.file = ''
        me.titleFile = me.externalPitch.photo
      }, 500)
    },
    actionRemove () {
      let me = this
      setTimeout(function () {
        me.pitchName = me.externalPitch.name
        me.image = me.externalPitch.photo ? urlAvatar + me.externalPitch.photo : ''
        me.file = ''
        me.titleFile = me.externalPitch.photo
      }, 500)
    },
    actionCreate () {
      let me = this
      setTimeout(function () {
        me.stadium = me.stadiumId
      }, 500)
      this.pitchName = ''
      this.image = ''
      this.file = ''
      this.titleFile = ''
    },
    verifyBeforeSend () {
      let result = true
      let message = []
      if (this.pitchName === '') {
        result = false
        message.push(this.$t('error.required', { field: this.$t('name') }))
      }
      if (this.stadiumId === '') {
        result = false
        message.push(this.$t('error.required', { field: this.$tc('stadium') }))
      }
      return {
        result,
        message
      }
    },
    createAula () {
      return {
        idStadium: this.stadiumId,
        pitch: {
          name: this.pitchName,
          photo: this.file
        }
      }
    },
    cancel () {
      this.reset()
      this.$emit('close')
    },
    create () {
      const error = this.verifyBeforeSend()
      if (!error.result) {
        queueToast(error.message)
        return
      }
      this.setCreate(this.createAula()).finally(() => this.cancel())
    },
    update () {
      const error = this.verifyBeforeSend()
      if (!error.result) {
        queueToast(error.message)
        return
      }
      let temporalData = this.createAula()
      temporalData.pitch._id = this.externalPitch._id
      this.setUpdate(temporalData).finally(() => this.cancel())
    },
    remove () {
      this.setRemove({
        idStadium: this.stadiumId,
        idPitch: this.externalPitch._id
      }).finally(() => this.cancel())
    },
    reset () {
      this.pitchName = ''
      this.image = ''
      this.file = ''
      this.titleFile = ''
    },
    fileChanged (file) {
      if (file.size < 1) return
      this.createImage(file)
    },
    createImage (file) {
      this.file = file
      this.titleFile = file.name
      const image = new Image()
      const reader = new FileReader()
      const vm = this

      reader.onload = (e) => {
        vm.image = e.target.result
      }
      reader.readAsDataURL(file)
    }
  }
}
</script>
